import {ButtonProps, IconButton} from '@mui/material';
import IconEdit from '../../asset/icons/icon_editbtn.svg';

const IconEditButton: React.FC<ButtonProps> = ({...buttonProps}) => {
  return (
    <IconButton
      {...buttonProps}
      color='primary'
      aria-label={buttonProps['aria-label'] || 'Edit'}
      title={buttonProps.title || 'Edit'}>
      {IconEdit && <img src={IconEdit} alt='' aria-hidden='true' />}
    </IconButton>
  );
};

export default IconEditButton;
